function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _temp;

var BasePlugin = require('@uppy/core/lib/BasePlugin');

var _require = require('nanoid/non-secure'),
    nanoid = _require.nanoid;

var _require2 = require('@uppy/companion-client'),
    Provider = _require2.Provider,
    RequestClient = _require2.RequestClient,
    Socket = _require2.Socket;

var emitSocketProgress = require('@uppy/utils/lib/emitSocketProgress');

var getSocketHost = require('@uppy/utils/lib/getSocketHost');

var settle = require('@uppy/utils/lib/settle');

var EventTracker = require('@uppy/utils/lib/EventTracker');

var ProgressTimeout = require('@uppy/utils/lib/ProgressTimeout');

var _require3 = require('@uppy/utils/lib/RateLimitedQueue'),
    RateLimitedQueue = _require3.RateLimitedQueue,
    internalRateLimitedQueue = _require3.internalRateLimitedQueue;

var NetworkError = require('@uppy/utils/lib/NetworkError');

var isNetworkError = require('@uppy/utils/lib/isNetworkError');

var locale = require('./locale');

function buildResponseError(xhr, err) {
  var error = err; // No error message

  if (!error) error = new Error('Upload error'); // Got an error message string

  if (typeof error === 'string') error = new Error(error); // Got something else

  if (!(error instanceof Error)) {
    error = Object.assign(new Error('Upload error'), {
      data: error
    });
  }

  if (isNetworkError(xhr)) {
    error = new NetworkError(error, xhr);
    return error;
  }

  error.request = xhr;
  return error;
}
/**
 * Set `data.type` in the blob to `file.meta.type`,
 * because we might have detected a more accurate file type in Uppy
 * https://stackoverflow.com/a/50875615
 *
 * @param {object} file File object with `data`, `size` and `meta` properties
 * @returns {object} blob updated with the new `type` set from `file.meta.type`
 */


function setTypeInBlob(file) {
  var dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
  return dataWithUpdatedType;
}

module.exports = (_temp = _class = /*#__PURE__*/function (_BasePlugin) {
  _inherits(XHRUpload, _BasePlugin);

  var _super = _createSuper(XHRUpload);

  // eslint-disable-next-line global-require
  function XHRUpload(uppy, opts) {
    var _this;

    _classCallCheck(this, XHRUpload);

    _this = _super.call(this, uppy, opts);
    _this.type = 'uploader';
    _this.id = _this.opts.id || 'XHRUpload';
    _this.title = 'XHRUpload';
    _this.defaultLocale = locale; // Default options

    var defaultOptions = {
      formData: true,
      fieldName: opts.bundle ? 'files[]' : 'file',
      method: 'post',
      metaFields: null,
      responseUrlFieldName: 'url',
      bundle: false,
      headers: {},
      timeout: 30 * 1000,
      limit: 5,
      withCredentials: false,
      responseType: '',

      /**
       * @typedef respObj
       * @property {string} responseText
       * @property {number} status
       * @property {string} statusText
       * @property {object.<string, string>} headers
       *
       * @param {string} responseText the response body string
       * @param {XMLHttpRequest | respObj} response the response object (XHR or similar)
       */
      getResponseData: function getResponseData(responseText) {
        var parsedResponse = {};

        try {
          parsedResponse = JSON.parse(responseText);
        } catch (err) {
          uppy.log(err);
        }

        return parsedResponse;
      },

      /**
       *
       * @param {string} responseText the response body string
       * @param {XMLHttpRequest | respObj} response the response object (XHR or similar)
       */
      getResponseError: function getResponseError(_, response) {
        var error = new Error('Upload error');

        if (isNetworkError(response)) {
          error = new NetworkError(error, response);
        }

        return error;
      },

      /**
       * Check if the response from the upload endpoint indicates that the upload was successful.
       *
       * @param {number} status the response status code
       */
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      }
    };
    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts);

    _this.i18nInit();

    _this.handleUpload = _this.handleUpload.bind(_assertThisInitialized(_this)); // Simultaneous upload limiting is shared across all uploads with this plugin.

    if (internalRateLimitedQueue in _this.opts) {
      _this.requests = _this.opts[internalRateLimitedQueue];
    } else {
      _this.requests = new RateLimitedQueue(_this.opts.limit);
    }

    if (_this.opts.bundle && !_this.opts.formData) {
      throw new Error('`opts.formData` must be true when `opts.bundle` is enabled.');
    }

    _this.uploaderEvents = Object.create(null);
    return _this;
  }

  _createClass(XHRUpload, [{
    key: "getOptions",
    value: function getOptions(file) {
      var overrides = this.uppy.getState().xhrUpload;
      var headers = this.opts.headers;

      var opts = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.opts), overrides || {}), file.xhrUpload || {}), {}, {
        headers: {}
      }); // Support for `headers` as a function, only in the XHRUpload settings.
      // Options set by other plugins in Uppy state or on the files themselves are still merged in afterward.
      //
      // ```js
      // headers: (file) => ({ expires: file.meta.expires })
      // ```


      if (typeof headers === 'function') {
        opts.headers = headers(file);
      } else {
        Object.assign(opts.headers, this.opts.headers);
      }

      if (overrides) {
        Object.assign(opts.headers, overrides.headers);
      }

      if (file.xhrUpload) {
        Object.assign(opts.headers, file.xhrUpload.headers);
      }

      return opts;
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "addMetadata",
    value: function addMetadata(formData, meta, opts) {
      var metaFields = Array.isArray(opts.metaFields) ? opts.metaFields : Object.keys(meta); // Send along all fields by default.

      metaFields.forEach(function (item) {
        formData.append(item, meta[item]);
      });
    }
  }, {
    key: "createFormDataUpload",
    value: function createFormDataUpload(file, opts) {
      var formPost = new FormData();
      this.addMetadata(formPost, file.meta, opts);
      var dataWithUpdatedType = setTypeInBlob(file);

      if (file.name) {
        formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
      } else {
        formPost.append(opts.fieldName, dataWithUpdatedType);
      }

      return formPost;
    }
  }, {
    key: "createBundledUpload",
    value: function createBundledUpload(files, opts) {
      var _this2 = this;

      var formPost = new FormData();

      var _this$uppy$getState = this.uppy.getState(),
          meta = _this$uppy$getState.meta;

      this.addMetadata(formPost, meta, opts);
      files.forEach(function (file) {
        var options = _this2.getOptions(file);

        var dataWithUpdatedType = setTypeInBlob(file);

        if (file.name) {
          formPost.append(options.fieldName, dataWithUpdatedType, file.name);
        } else {
          formPost.append(options.fieldName, dataWithUpdatedType);
        }
      });
      return formPost;
    }
  }, {
    key: "upload",
    value: function upload(file, current, total) {
      var _this3 = this;

      var opts = this.getOptions(file);
      this.uppy.log("uploading ".concat(current, " of ").concat(total));
      return new Promise(function (resolve, reject) {
        _this3.uppy.emit('upload-started', file);

        var data = opts.formData ? _this3.createFormDataUpload(file, opts) : file.data;
        var xhr = new XMLHttpRequest();
        _this3.uploaderEvents[file.id] = new EventTracker(_this3.uppy);
        var timer = new ProgressTimeout(opts.timeout, function () {
          xhr.abort();
          queuedRequest.done();
          var error = new Error(_this3.i18n('timedOut', {
            seconds: Math.ceil(opts.timeout / 1000)
          }));

          _this3.uppy.emit('upload-error', file, error);

          reject(error);
        });
        var id = nanoid();
        xhr.upload.addEventListener('loadstart', function () {
          _this3.uppy.log("[XHRUpload] ".concat(id, " started"));
        });
        xhr.upload.addEventListener('progress', function (ev) {
          _this3.uppy.log("[XHRUpload] ".concat(id, " progress: ").concat(ev.loaded, " / ").concat(ev.total)); // Begin checking for timeouts when progress starts, instead of loading,
          // to avoid timing out requests on browser concurrency queue


          timer.progress();

          if (ev.lengthComputable) {
            _this3.uppy.emit('upload-progress', file, {
              uploader: _this3,
              bytesUploaded: ev.loaded,
              bytesTotal: ev.total
            });
          }
        });
        xhr.addEventListener('load', function (ev) {
          _this3.uppy.log("[XHRUpload] ".concat(id, " finished"));

          timer.done();
          queuedRequest.done();

          if (_this3.uploaderEvents[file.id]) {
            _this3.uploaderEvents[file.id].remove();

            _this3.uploaderEvents[file.id] = null;
          }

          if (opts.validateStatus(ev.target.status, xhr.responseText, xhr)) {
            var _body = opts.getResponseData(xhr.responseText, xhr);

            var uploadURL = _body[opts.responseUrlFieldName];
            var uploadResp = {
              status: ev.target.status,
              body: _body,
              uploadURL: uploadURL
            };

            _this3.uppy.emit('upload-success', file, uploadResp);

            if (uploadURL) {
              _this3.uppy.log("Download ".concat(file.name, " from ").concat(uploadURL));
            }

            return resolve(file);
          }

          var body = opts.getResponseData(xhr.responseText, xhr);
          var error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
          var response = {
            status: ev.target.status,
            body: body
          };

          _this3.uppy.emit('upload-error', file, error, response);

          return reject(error);
        });
        xhr.addEventListener('error', function () {
          _this3.uppy.log("[XHRUpload] ".concat(id, " errored"));

          timer.done();
          queuedRequest.done();

          if (_this3.uploaderEvents[file.id]) {
            _this3.uploaderEvents[file.id].remove();

            _this3.uploaderEvents[file.id] = null;
          }

          var error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));

          _this3.uppy.emit('upload-error', file, error);

          return reject(error);
        });
        xhr.open(opts.method.toUpperCase(), opts.endpoint, true); // IE10 does not allow setting `withCredentials` and `responseType`
        // before `open()` is called.

        xhr.withCredentials = opts.withCredentials;

        if (opts.responseType !== '') {
          xhr.responseType = opts.responseType;
        }

        var queuedRequest = _this3.requests.run(function () {
          _this3.uppy.emit('upload-started', file); // When using an authentication system like JWT, the bearer token goes as a header. This
          // header needs to be fresh each time the token is refreshed so computing and setting the
          // headers just before the upload starts enables this kind of authentication to work properly.
          // Otherwise, half-way through the list of uploads the token could be stale and the upload would fail.


          var currentOpts = _this3.getOptions(file);

          Object.keys(currentOpts.headers).forEach(function (header) {
            xhr.setRequestHeader(header, currentOpts.headers[header]);
          });
          xhr.send(data);
          return function () {
            timer.done();
            xhr.abort();
          };
        });

        _this3.onFileRemove(file.id, function () {
          queuedRequest.abort();
          reject(new Error('File removed'));
        });

        _this3.onCancelAll(file.id, function () {
          queuedRequest.abort();
          reject(new Error('Upload cancelled'));
        });
      });
    }
  }, {
    key: "uploadRemote",
    value: function uploadRemote(file) {
      var _this4 = this;

      var opts = this.getOptions(file);
      return new Promise(function (resolve, reject) {
        _this4.uppy.emit('upload-started', file);

        var fields = {};
        var metaFields = Array.isArray(opts.metaFields) ? opts.metaFields // Send along all fields by default.
        : Object.keys(file.meta);
        metaFields.forEach(function (name) {
          fields[name] = file.meta[name];
        });
        var Client = file.remote.providerOptions.provider ? Provider : RequestClient;
        var client = new Client(_this4.uppy, file.remote.providerOptions);
        client.post(file.remote.url, _objectSpread(_objectSpread({}, file.remote.body), {}, {
          endpoint: opts.endpoint,
          size: file.data.size,
          fieldname: opts.fieldName,
          metadata: fields,
          httpMethod: opts.method,
          useFormData: opts.formData,
          headers: opts.headers
        })).then(function (res) {
          var token = res.token;
          var host = getSocketHost(file.remote.companionUrl);
          var socket = new Socket({
            target: "".concat(host, "/api/").concat(token),
            autoOpen: false
          });
          _this4.uploaderEvents[file.id] = new EventTracker(_this4.uppy);

          _this4.onFileRemove(file.id, function () {
            socket.send('cancel', {});
            queuedRequest.abort();
            resolve("upload ".concat(file.id, " was removed"));
          });

          _this4.onCancelAll(file.id, function () {
            socket.send('cancel', {});
            queuedRequest.abort();
            resolve("upload ".concat(file.id, " was canceled"));
          });

          _this4.onRetry(file.id, function () {
            socket.send('pause', {});
            socket.send('resume', {});
          });

          _this4.onRetryAll(file.id, function () {
            socket.send('pause', {});
            socket.send('resume', {});
          });

          socket.on('progress', function (progressData) {
            return emitSocketProgress(_this4, progressData, file);
          });
          socket.on('success', function (data) {
            var body = opts.getResponseData(data.response.responseText, data.response);
            var uploadURL = body[opts.responseUrlFieldName];
            var uploadResp = {
              status: data.response.status,
              body: body,
              uploadURL: uploadURL
            };

            _this4.uppy.emit('upload-success', file, uploadResp);

            queuedRequest.done();

            if (_this4.uploaderEvents[file.id]) {
              _this4.uploaderEvents[file.id].remove();

              _this4.uploaderEvents[file.id] = null;
            }

            return resolve();
          });
          socket.on('error', function (errData) {
            var resp = errData.response;
            var error = resp ? opts.getResponseError(resp.responseText, resp) : Object.assign(new Error(errData.error.message), {
              cause: errData.error
            });

            _this4.uppy.emit('upload-error', file, error);

            queuedRequest.done();

            if (_this4.uploaderEvents[file.id]) {
              _this4.uploaderEvents[file.id].remove();

              _this4.uploaderEvents[file.id] = null;
            }

            reject(error);
          });

          var queuedRequest = _this4.requests.run(function () {
            socket.open();

            if (file.isPaused) {
              socket.send('pause', {});
            }

            return function () {
              return socket.close();
            };
          });
        }).catch(function (err) {
          _this4.uppy.emit('upload-error', file, err);

          reject(err);
        });
      });
    }
  }, {
    key: "uploadBundle",
    value: function uploadBundle(files) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        var endpoint = _this5.opts.endpoint;
        var method = _this5.opts.method;

        var optsFromState = _this5.uppy.getState().xhrUpload;

        var formData = _this5.createBundledUpload(files, _objectSpread(_objectSpread({}, _this5.opts), optsFromState || {}));

        var xhr = new XMLHttpRequest();
        var timer = new ProgressTimeout(_this5.opts.timeout, function () {
          xhr.abort();
          var error = new Error(_this5.i18n('timedOut', {
            seconds: Math.ceil(_this5.opts.timeout / 1000)
          }));
          emitError(error);
          reject(error);
        });

        var emitError = function emitError(error) {
          files.forEach(function (file) {
            _this5.uppy.emit('upload-error', file, error);
          });
        };

        xhr.upload.addEventListener('loadstart', function () {
          _this5.uppy.log('[XHRUpload] started uploading bundle');

          timer.progress();
        });
        xhr.upload.addEventListener('progress', function (ev) {
          timer.progress();
          if (!ev.lengthComputable) return;
          files.forEach(function (file) {
            _this5.uppy.emit('upload-progress', file, {
              uploader: _this5,
              bytesUploaded: ev.loaded / ev.total * file.size,
              bytesTotal: file.size
            });
          });
        });
        xhr.addEventListener('load', function (ev) {
          timer.done();

          if (_this5.opts.validateStatus(ev.target.status, xhr.responseText, xhr)) {
            var body = _this5.opts.getResponseData(xhr.responseText, xhr);

            var uploadResp = {
              status: ev.target.status,
              body: body
            };
            files.forEach(function (file) {
              _this5.uppy.emit('upload-success', file, uploadResp);
            });
            return resolve();
          }

          var error = _this5.opts.getResponseError(xhr.responseText, xhr) || new Error('Upload error');
          error.request = xhr;
          emitError(error);
          return reject(error);
        });
        xhr.addEventListener('error', function () {
          timer.done();
          var error = _this5.opts.getResponseError(xhr.responseText, xhr) || new Error('Upload error');
          emitError(error);
          return reject(error);
        });

        _this5.uppy.on('cancel-all', function () {
          timer.done();
          xhr.abort();
        });

        xhr.open(method.toUpperCase(), endpoint, true); // IE10 does not allow setting `withCredentials` and `responseType`
        // before `open()` is called.

        xhr.withCredentials = _this5.opts.withCredentials;

        if (_this5.opts.responseType !== '') {
          xhr.responseType = _this5.opts.responseType;
        }

        Object.keys(_this5.opts.headers).forEach(function (header) {
          xhr.setRequestHeader(header, _this5.opts.headers[header]);
        });
        xhr.send(formData);
        files.forEach(function (file) {
          _this5.uppy.emit('upload-started', file);
        });
      });
    }
  }, {
    key: "uploadFiles",
    value: function uploadFiles(files) {
      var _this6 = this;

      var promises = files.map(function (file, i) {
        var current = parseInt(i, 10) + 1;
        var total = files.length;

        if (file.error) {
          return Promise.reject(new Error(file.error));
        }

        if (file.isRemote) {
          return _this6.uploadRemote(file, current, total);
        }

        return _this6.upload(file, current, total);
      });
      return settle(promises);
    }
  }, {
    key: "onFileRemove",
    value: function onFileRemove(fileID, cb) {
      this.uploaderEvents[fileID].on('file-removed', function (file) {
        if (fileID === file.id) cb(file.id);
      });
    }
  }, {
    key: "onRetry",
    value: function onRetry(fileID, cb) {
      this.uploaderEvents[fileID].on('upload-retry', function (targetFileID) {
        if (fileID === targetFileID) {
          cb();
        }
      });
    }
  }, {
    key: "onRetryAll",
    value: function onRetryAll(fileID, cb) {
      var _this7 = this;

      this.uploaderEvents[fileID].on('retry-all', function () {
        if (!_this7.uppy.getFile(fileID)) return;
        cb();
      });
    }
  }, {
    key: "onCancelAll",
    value: function onCancelAll(fileID, cb) {
      var _this8 = this;

      this.uploaderEvents[fileID].on('cancel-all', function () {
        if (!_this8.uppy.getFile(fileID)) return;
        cb();
      });
    }
  }, {
    key: "handleUpload",
    value: function handleUpload(fileIDs) {
      var _this9 = this;

      if (fileIDs.length === 0) {
        this.uppy.log('[XHRUpload] No files to upload!');
        return Promise.resolve();
      } // No limit configured by the user, and no RateLimitedQueue passed in by a "parent" plugin
      // (basically just AwsS3) using the internal symbol


      if (this.opts.limit === 0 && !this.opts[internalRateLimitedQueue]) {
        this.uppy.log('[XHRUpload] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/xhr-upload/#limit-0', 'warning');
      }

      this.uppy.log('[XHRUpload] Uploading...');
      var files = fileIDs.map(function (fileID) {
        return _this9.uppy.getFile(fileID);
      });

      if (this.opts.bundle) {
        // if bundle: true, we don’t support remote uploads
        var isSomeFileRemote = files.some(function (file) {
          return file.isRemote;
        });

        if (isSomeFileRemote) {
          throw new Error('Can’t upload remote files when the `bundle: true` option is set');
        }

        if (typeof this.opts.headers === 'function') {
          throw new TypeError('`headers` may not be a function when the `bundle: true` option is set');
        }

        return this.uploadBundle(files);
      }

      return this.uploadFiles(files).then(function () {
        return null;
      });
    }
  }, {
    key: "install",
    value: function install() {
      if (this.opts.bundle) {
        var _this$uppy$getState2 = this.uppy.getState(),
            capabilities = _this$uppy$getState2.capabilities;

        this.uppy.setState({
          capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
            individualCancellation: false
          })
        });
      }

      this.uppy.addUploader(this.handleUpload);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      if (this.opts.bundle) {
        var _this$uppy$getState3 = this.uppy.getState(),
            capabilities = _this$uppy$getState3.capabilities;

        this.uppy.setState({
          capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
            individualCancellation: true
          })
        });
      }

      this.uppy.removeUploader(this.handleUpload);
    }
  }]);

  return XHRUpload;
}(BasePlugin), _class.VERSION = "2.0.7", _temp);